/**
 * This simple type specifies scaling point location.
 * This will be useful for scallign.
 */
export enum PageObjectScalePointType {
    /** Left Top Corner */
    CORNER_LEFT_TOP = "CORNER_LEFT_TOP",

    /** Left Top Corner */
    CORNER_RIGHT_TOP = "CORNER_RIGHT_TOP",

    /** Left Bottom Corner */
    CORNER_LEFT_BOTTOM = "CORNER_LEFT_BOTTOM",

    /** Right Bottom Corner */
    CORNER_RIGHT_BOTTOM = "CORNER_RIGHT_BOTTOM",

    /** Top Side */
    SIDE_TOP = "SIDE_TOP",

    /** Right Side */
    SIDE_RIGHT = "SIDE_RIGHT",

    /** Bottom Side */
    SIDE_BOTTOM = "SIDE_BOTTOM",

    /** Left Side */
    SIDE_LEFT = "SIDE_LEFT",
}
